import {LayoutContext, LayoutType} from 'components/Layout/context';
import {useContext} from 'react';

const useLayout = (): LayoutType => {
    const context = useContext(LayoutContext);
    if (!context) return 'stacked';
    return context.type;
};

export default useLayout;
